// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"17":"6be305f3","841":"966ea52a"}[chunkId] + ".chunk.css";
};